import React from 'react'
import Slider from 'react-slick'
import PropTypes from 'prop-types'

import ImageFallback from 'Components/imagefallback/next_image'

const settings = {
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  useTransform: false,
}

const totalBanner = parseInt(process.env.NEXT_PUBLIC_MALE_DAILY_BANNER_TOTAL) || 0;
const imageEmpty = process.env.NEXT_PUBLIC_S3_IMAGE_EMPTY_3_1
const imageEmptyMobile = process.env.NEXT_PUBLIC_S3_IMAGE_EMPTY_1_1
const imageBroken = process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_3_1
const imageBrokenMobile = process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_1_1

const images = [
  {
    id: 1,
    urlDesktop: process.env.NEXT_PUBLIC_MALE_DAILY_BANNER_1 || imageEmpty,
    urlMobile: process.env.NEXT_PUBLIC_MALE_DAILY_MOBILE_BANNER_1 || imageEmptyMobile,
    name: 'Banner',
  },
  {
    id: 2,
    urlDesktop: process.env.NEXT_PUBLIC_MALE_DAILY_BANNER_2 || imageEmpty,
    urlMobile: process.env.NEXT_PUBLIC_MALE_DAILY_MOBILE_BANNER_2 || imageEmptyMobile,
    name: 'Banner',
  },
  {
    id: 3,
    urlDesktop: process.env.NEXT_PUBLIC_MALE_DAILY_BANNER_3 || imageEmpty,
    urlMobile: process.env.NEXT_PUBLIC_MALE_DAILY_MOBILE_BANNER_3 || imageEmptyMobile,
    name: 'Banner',
  },
]

const MaleDailyBanner = ({ isMobile }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <div className={`maledaily-banner maledaily-banner--${device}`}>
        <Slider {...settings} dots={totalBanner > 1}>
          {images.slice(0, totalBanner).map((image) => (
            <div key={image.id}>
              <div
                className={`maledaily-banner__item maledaily-banner__item--${device}`}
              >
                <ImageFallback
                  className="maledaily-banner__image"
                  priority
                  objectFit="cover"
                  alt={image.name}
                  src={isMobile ? image.urlMobile : image.urlDesktop}
                  fallbackSrc={isMobile ? imageBrokenMobile : imageBroken}
                  width={isMobile ? 480 : 1440}
                  height={isMobile ? 480 : 478}
                  quality={100}
                  style={{ aspectRatio: isMobile ? '1/1' : '3/1' }}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <style jsx>
        {`
          .maledaily-banner {
            width: 100%;
            max-width: 1440px;
            margin: auto;
          }

          .maledaily-banner--mobile {
            width: 100%;
            max-width: 480px;
          }

          .maledaily-banner__item {
            display: flex;
            justify-content: center;
            align-items: center;
            aspect-ratio: 3/1 auto;
            width: 100%;
            max-width: 1440px;
            margin: auto;
          }

          .maledaily-banner__item--mobile {
            aspect-ratio: 1/1 auto;
            max-width: 480px;
          }
        `}
      </style>
      <style jsx global>
        {`
          .maledaily-banner .slick-dots {
            bottom: 20px;
            text-align: center;
            color: #000000;
          }
          .maledaily-banner .slick-dots li {
            width: 8px;
            height: 8px;
            position: relative;
            transition: margin 0.2s ease-out;
          }
          .maledaily-banner .slick-dots li.slick-active {
            margin: 0 var(--space-12) !important;
          }
          .maledaily-banner .slick-dots li.slick-active:nth-child(1) {
            margin-left: 0;
          }
          .maledaily-banner .slick-dots li.slick-active:nth-last-child(1) {
            margin-right: 0;
          }
          .maledaily-banner .slick-dots li button {
            width: 24px;
            height: 8px;
            position: relative;
            padding: 0;
          }
          .maledaily-banner .slick-dots li button:before {
            content: close-quote;
            background-color: #000000;
            opacity: 0.3;
            transition: all 0.2s ease;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            left: 50%;
            transform: translateX(-50%);
          }
          .maledaily-banner .slick-dots li.slick-active button {
            width: 24px;
          }
          .maledaily-banner .slick-dots li.slick-active button:before {
            width: 24px;
            opacity: 1;
            border-radius: var(--radius-4);
            background-color: #000000;
          }
        `}
      </style>
    </>
  )
}

MaleDailyBanner.propTypes = {
  isMobile: PropTypes.bool,
}

export default MaleDailyBanner
